module.exports = __webpack_public_path__ + "static/media/Liam Christensen.81985694.jpeg";